(function ($) {
  csInternalPageSectionRowV1 = {
    formatter: $('.cs-internal-page-section-row-v1')
  };

  Drupal.behaviors.csInternalPageSectionRowV1 = {
    get: function (key) {
      return csInternalPageSectionRowV1[key];
    },

    set: function (key, val) {
      csInternalPageSectionRowV1[key] = val;
    },

    attach: function (context, settings) {
      var self = this;
      var formatter = self.get('formatter');

      formatter.each(function () {
        var thisFormatter = $(this);
      });
    }
  };
})(jQuery);
